import { FC } from "react";
import Cards, { Focused } from "react-credit-cards-2";
import "react-credit-cards-2/dist/es/styles-compiled.css";

interface RenderSidebarProps {
  formik?: any;
  infoCardFocus: string;
}

const RenderSidebar: FC<RenderSidebarProps> = ({ formik, infoCardFocus }) => {
  return (
    <div className="w-full flex flex-col sm:rounded-2xl lg:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 px-0 sm:p-6 xl:p-8">
      <div className="flex flex-col space-y-4">
        <Cards
          cvc={formik.values.cvc}
          expiry={formik.values.expiry}
          focused={infoCardFocus as Focused}
          name={formik.values.name}
          number={formik.values.number}
          locale={{ valid: "valido até" }}
          preview={true}
          placeholders={{ name: "NOME DO TITULAR" }}
        />
      </div>
    </div>
  );
};

export default RenderSidebar;
